import * as React from "react";
import CustomizableDatagrid from 'ra-customizable-datagrid';
import { TextField, List, DateField, ArrayField, Show,  NumberField, Datagrid, ReferenceField, SimpleShowLayout, NumberInput,
   TextInput, required, Edit, SimpleForm, ArrayInput, SimpleFormIterator, Create, DateTimeInput } from "react-admin";
import { idFilter } from "../util/filters";

export const ReportList = props => (
    <List filters={idFilter} {...props} bulkActionButtons={false}>
        <CustomizableDatagrid rowClick="show">
            <TextField source="id" />
            <DateField source="modification_date" showTime={true}/>
            <ReferenceField source="booking_id" reference="bookings">
                <TextField source="id" />
            </ReferenceField>
            <ReferenceField source="mfa_id" reference="mfas">
                <TextField source="id" />
            </ReferenceField>
            <ReferenceField source="provider_id" reference="businessentities">
                <TextField source="id" />
            </ReferenceField>
        </CustomizableDatagrid>
    </List>
);

export const ReportShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <DateField source="modification_date" showTime={true}/>
            <ReferenceField source="booking_id" reference="bookings">
                <TextField source="id" />
            </ReferenceField>
            <ReferenceField source="mfa_id" reference="mfas">
                <TextField source="id" />
            </ReferenceField>
            <ReferenceField source="provider_id" reference="businessentities">
                <TextField source="id" />
            </ReferenceField>
            <ArrayField source="etus">
                <Datagrid>
                    <DateField source="date" showTime={true}/>
                    <NumberField source="energy" />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);

export const ReportEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
            <TextInput source="booking_id" validate={required()}/>
            <TextInput source="mfa_id" validate={required()}/>
            <ArrayInput source="etus" validate={required()}>
                <SimpleFormIterator>
                    <DateTimeInput source="date" validate={required()}/>
                    <NumberInput source="energy" validate={required()}/>
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Edit>
);

export const ReportCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="booking_id" validate={required()}/>
            <TextInput source="mfa_id" validate={required()}/>
            <ArrayInput source="etus" validate={required()}>
                <SimpleFormIterator>
                    <DateTimeInput source="date" validate={required()}/>
                    <NumberInput source="energy" validate={required()}/>
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);